import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgaben-benutzer-berechtigungen-hinzufuegen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabenBenutzerBerechtigungenHinzufuegenEffects {

    AufgabenBenutzerBerechtigungenHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN),
        mergeMap((x: ac.PostAufgabenBenutzerBerechtigungenHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabenBenutzerBerechtigungenHinzufuegen(x.aufgabenBenutzerIdsRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabenBenutzerBerechtigungenHinzufuegenErfolgreichAction(x.aufgabenBenutzerIdsRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabenBenutzerBerechtigungenHinzufuegenFehlerAction(error, x.aufgabenBenutzerIdsRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
